export default {
  API_ENDPOINT: `https://mysterious-reaches-82332.herokuapp.com/api/bookmarks`,
  API_KEY: process.env.REACT_APP_API_KEY
}
